<template>
  <div>
    <header>
      <h1 class="page-title">Datos de la ponencia</h1>
    </header>
    
    <hr>
    
    <div class="mt-2 mb-4">
      <div class="nav-scroller border-bottom">
        <div class="nav nav-tabs active" ref="tabs">
          <a href="#consult"
             class="nav-link active"
             data-toggle="tab">
            Consultar ponencia</a>
          <a href="#validate"
             class="nav-link"
             data-toggle="tab">
            Validar ponencia</a>
          <a :href="`/curriculo/ponencia/indicador/${task.taskable.id}/editar`"
             class="nav-link">
            Editar ponencia</a>
          <a href="#delete"
             class="nav-link"
             data-toggle="tab"
             @click="showDeleteModal">
            Eliminar ponencia</a>
        </div>
      </div>
    </div>
    
    <div class="tab-content">
      <div class="tab-pane active show" id="consult"
           role="tabpanel"
           aria-labelledby="format-tab-title">
        
        <div class="w-100"
             v-if="task.taskable && task.taskable.factor_magazine && task.taskable.factor_magazine.magazine">
          <p class="font-weight-bold h4 text-primary">Revista seleccionada</p>
          
          <div class="w-100">
            <h1 class="h5">{{ task.taskable.factor_magazine.magazine.title }}</h1>
            
            <div>
              <span class="font-weight-bold">ISSN:</span>
              <span>{{ task.taskable.factor_magazine.magazine.issn }}</span>
            </div>
            
            <div>
              <span class="font-weight-bold">Grupo:</span>
              <span>{{ task.taskable.factor_magazine.group }}</span>
            </div>
            
            <div>
              <span class="font-weight-bold">Factor de impacto:</span>
              <span>{{ task.taskable.factor_magazine.impact }}</span>
            </div>
          </div>
        </div>
        
        <hr class="my-4">
        
        <div class="w-100">
          <p class="font-weight-bold h4 text-primary">Datos de la ponencia</p>
          <hr>
          
          <div class="form-group mb-4">
            <label for="title">Nombre del evento:</label>
            <input type="text"
                   name="event_name"
                   id="event_name"
                   v-model="task.taskable.event_name"
                   class="form-control readonly"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="organizing_institution">Institución organizadora: </label>
            <input type="text"
                   name="organizing_institution"
                   id="organizing_institution"
                   v-model="task.taskable.organizing_institution"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <div class="form-row">
              <div class="col-12 col-md-3">
                <label for="year">Año:</label>
                <input type="text"
                       name="year"
                       id="year"
                       size="4"
                       v-model="task.taskable.year"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>
              
              <div class="col-12 col-md-8">
                <label for="event_type">Tipo de evento:</label>
                <input type="text"
                       name="event_type"
                       id="event_type"
                       v-model="task.taskable.event_type"
                       class="form-control readonly w-auto text-capitalize"
                       readonly
                       disabled/>
              </div>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <label for="organizing_institution">Título del trabajo: </label>
            <input type="text"
                   name="title"
                   id="title"
                   v-model="task.taskable.title"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="authors_citation">Nombre de citación de los autores: </label>
            <textarea rows="3"
                      cols="5"
                      name="authors_citation"
                      id="authors_citation"
                      v-model="task.taskable.authors_citation"
                      class="form-control"
                      readonly
                      disabled></textarea>
          </div>
          
          <div class="form-group mb-4">
            <label for="summary">Resumen: </label>
            <textarea rows="5"
                      cols="5"
                      name="summary"
                      id="summary"
                      v-model="task.taskable.summary"
                      class="form-control"
                      readonly
                      disabled></textarea>
          </div>
          
          <div class="form-group mb-4">
            <label for="keywords_english">Keywords (Inglés): </label>
            <input type="text"
                   name="keywords_english"
                   id="keywords_english"
                   v-model="task.taskable.keywords_english"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <span class="font-weight-bold">Comprobante Seleccionado: </span>
            <a :href="`/${task.taskable.file_path}`" target="_blank"
               :download="task.taskable.file_name">{{ task.taskable.file_name }}</a>
          </div>
          
          <div class="form-group mb-4">
            <label for="presentation_date d-block">Fecha de presentación: </label>
            <input type="text"
                   name="presentation_date"
                   id="presentation_date"
                   :value="new Date(task.taskable.presentation_date).toLocaleString()"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <div class="form-row">
              <div class="col-12 col-md-4">
                <label for="city">Ciudad: </label>
                <input type="text"
                       name="city"
                       id="city"
                       v-model="task.taskable.city"
                       class="form-control"
                       readonly
                       disabled/>
              </div>
              <div class="col-12 col-md-4">
                <label for="country">País: </label>
                <input type="text"
                       name="country"
                       id="country"
                       :value="task.taskable.country ? task.taskable.country.name : ''"
                       class="form-control"
                       readonly
                       disabled/>
              </div>
              <div class="col-12 col-md-4">
                <label for="language">Idioma en que fue presentado el trabajo: </label>
                <input type="text"
                       name="language"
                       id="language"
                       :value="task.taskable.language ? task.taskable.language.name : ''"
                       class="form-control"
                       readonly
                       disabled/>
              </div>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <label for="presentation_type">Tipo de la presentación del trabajo:</label>
            <input type="text"
                   name="presentation_type"
                   id="presentation_type"
                   :value="task.taskable.presentation_type ? task.taskable.presentation_type.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <span class="font-weight-bold">¿En colaboración con INSyHAE?:</span>
            <div class="custom-control custom-control-inline custom-radio">
              <input type="radio"
                     class="custom-control-input"
                     name="insyhae_collaboration"
                     id="insyhae_collaboration_yes"
                     readonly
                     disabled
                     :checked="task.taskable.insyhae_collaboration === 1">
              <label class="custom-control-label"
                     for="insyhae_collaboration_yes">Si</label>
            </div>
            <div class="custom-control custom-control-inline custom-radio">
              <input type="radio"
                     class="custom-control-input"
                     name="insyhae_collaboration"
                     id="insyhae_collaboration_no"
                     readonly
                     disabled
                     :checked="task.taskable.insyhae_collaboration !== 1">
              <label class="custom-control-label"
                     for="insyhae_collaboration_no">No</label>
            </div>
            
            <div class="form-group mt-4" v-if="task.taskable.insyhae_collaboration === 1">
            
            </div>
          </div>
          
          <div class="form-group mb-4">
            <span class="font-weight-bold">Es relacionado con un proyecto de investigación del INSP:</span>
            <div class="custom-control custom-control-inline custom-radio">
              <input type="radio"
                     class="custom-control-input"
                     name="project_related"
                     id="project_related_yes"
                     readonly
                     disabled
                     :checked="task.taskable.project_related === 1">
              <label class="custom-control-label"
                     for="project_related_yes">Si</label>
            </div>
            <div class="custom-control custom-control-inline custom-radio">
              <input type="radio"
                     class="custom-control-input"
                     name="project_related"
                     id="project_related_no"
                     readonly
                     disabled
                     :checked="task.taskable.project_related !== 1">
              <label class="custom-control-label"
                     for="project_related_no">No</label>
            </div>
            
            <div class="form-group mt-4" v-if="task.taskable.project_related === 1">
            
            </div>
            <div class="form-group mt-4" v-else>
              <label for="summary">Justificación: </label>
              <textarea rows="5"
                        cols="5"
                        name="justification"
                        id="justification"
                        v-model="task.taskable.justification"
                        class="form-control"
                        readonly
                        disabled></textarea>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <label for="research_line">Línea de investigación: </label>
            <input type="text"
                   name="research_line"
                   id="research_line"
                   :value="task.taskable.research_line ? task.taskable.research_line.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="research_subline">Sublínea de investigación: </label>
            <input type="text"
                   name="research_subline"
                   id="research_subline"
                   :value="task.taskable.research_subline ? task.taskable.research_subline.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="financing_type">Tipo de financiamiento: </label>
            <input type="text"
                   name="financing_type"
                   id="financing_type"
                   :value="task.taskable.financing_type"
                   class="form-control text-capitalize"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="research_type">Área de investigación: </label>
            <input type="text"
                   name="research_type"
                   id="research_type"
                   :value="task.taskable.research_type ? task.taskable.research_type.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group mb-4">
            <label for="demand_sector">Demanda sector:</label>
            <input type="text"
                   name="demand_sector"
                   id="demand_sector"
                   :value="task.taskable.demand_sector ? task.taskable.demand_sector.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
            
            <div class="mt-4" v-if="task.taskable.demand_sector.title === 'Otra'">
              <label for="another_demand">Especifique la demanda sector:</label>
              <input type="text"
                     name="another_demand"
                     id="another_demand"
                     :value="task.taskable.another_demand ? task.taskable.another_demand : ''"
                     class="form-control"
                     readonly
                     disabled/>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <span class="font-weight-bold">Alumnos asignados:</span>
            
            <div class="list-group list-group-bordered mt-2" v-if="task.taskable.students.length">
              <a href="#"
                 @click.prevent=""
                 class="list-group-item list-group-item-action"
                 v-for="student in task.taskable.students"
                 :key="student.id">
                <div class="list-group-item-figure">
                  <div class="user-avatar">
                    <img :src="student.avatar" :alt="student.full_name">
                  </div>
                </div>
                <div class="list-group-item-body">{{student.full_name}}</div>
              </a>
            </div>
            
            <div v-else class="mt-3">
              <p class="alert alert-warning">No se asignaron alumnos.</p>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <span class="font-weight-bold">Autores asignados:</span>
            
            <div class="list-group list-group-bordered mt-2" v-if="task.taskable.authors.length">
              <a href="#"
                 @click.prevent=""
                 class="list-group-item list-group-item-action"
                 v-for="author in task.taskable.authors"
                 :key="author.id">
                <div class="list-group-item-figure">
                  <div class="user-avatar">
                    <img :src="author.avatar" :alt="author.full_name">
                  </div>
                </div>
                <div class="list-group-item-body">
                  {{author.full_name}}
                  <br>
                  <span class="badge text-sm badge-info">{{ participationTitles[author.pivot.participation_type] }}</span>
                </div>
              </a>
            </div>
            
            <div v-else class="mt-3">
              <p class="alert alert-warning">No se asignaron autores.</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="tab-pane" id="validate"
           role="tabpanel"
           aria-labelledby="format-tab-title">
        
        <form id="frm-validate"
              ref="frm-validate"
              accept-charset="UTF-8"
              onsubmit="return false">
          <div v-if="task.classification.key === 'revision_ponencia_subdirector_academico'">
            <div class="form-group mb-4">
              <p class="font-weight-bold">
                ¿Aprobado para enviar al Comité de investigación?: *
              </p>
              <div class="form-check form-check-inline">
                <input type="radio"
                       id="validated_true"
                       name="validated"
                       class="form-check-input"
                       value="1"
                       v-model="validated">
                <label for="validated_true"
                       class="form-check-label font-weight-normal">Si</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio"
                       id="validated_false"
                       name="validated"
                       class="form-check-input"
                       value="0"
                       v-model="validated">
                <label for="validated_false"
                       class="form-check-label font-weight-normal">No</label>
              </div>
              <div data-name="validated"></div>
            </div>
          </div>
          <div v-else>
            <div class="form-group mb-4">
              <p class="font-weight-bold">
                ¿Incluir la ponencia en indicadores?: *
              </p>
              <div class="form-check form-check-inline">
                <input type="radio"
                       id="is_included_on_indicators_true"
                       name="is_included_on_indicators"
                       class="form-check-input"
                       value="1"
                       v-model="isIncludedOnIndicators">
                <label for="is_included_on_indicators_true"
                       class="form-check-label font-weight-normal">Si</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="radio"
                       id="is_included_on_indicators_false"
                       name="is_included_on_indicators"
                       class="form-check-input"
                       value="0"
                       v-model="isIncludedOnIndicators">
                <label for="is_included_on_indicators_false"
                       class="form-check-label font-weight-normal">No</label>
              </div>
              <div data-name="is_included_on_indicators"></div>
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="comments">Comentarios:</label>
            <textarea rows="5"
                      cols="5"
                      name="comments"
                      id="comments"
                      class="form-control"
                      v-model="comments"></textarea>
          </div>
          <button class="btn btn-lg btn-primary mr-2"
                  type="submit">Validar
          </button>
        </form>
      
      </div>
      
      <portal to="protocol-modals">
        <ok-cancel-dialog id="delete-modal"
                          ref="delete-modal"
                          title="Eliminar ponencia"
                          content="<p>¿Esta seguro de eliminar esta ponencia?</p>"
                          ok-button-text="Eliminar"
                          @ok-button-pressed="deletePresentationIndicator"></ok-cancel-dialog>
        
        <ok-cancel-dialog id="validate-modal"
                          ref="validate-modal"
                          title="Validar ponencia"
                          :content="modalMessage"
                          ok-button-text="Validar"
                          @ok-button-pressed="validate"></ok-cancel-dialog>
      </portal>
    </div>
  </div>
</template>

<script>
  import 'jquery-validation'
  import FilesList from '../protocols/FilesList'
  import ProtocolHeader from '../protocols/commons/ProtocolHeader'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import autosize from 'autosize'
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'ValidatePresentation',
    components: {
      OkCancelDialog,
      FilesList,
      ProtocolHeader,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    methods: {
      ...mapActions({
        validatePresentation: 'presentations/validatePresentation',
        validatePresentationByResearchCommittee: 'presentations/validatePresentationByResearchCommittee',
        deletePresentation: 'presentations/deletePresentation',
      }),
      
      showDeleteModal () {
        $('#delete-modal').modal('show')
      },
      
      async deletePresentationIndicator () {
        this.$refs['delete-modal'].sending = true
        
        const response = await this.deletePresentation({
          presentation: this.task.taskable.id,
          task_id: this.task.id,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        this.$refs['delete-modal'].sending = false
        this.$refs['delete-modal'].close()
        location.href = '/dashboard'
      },
      
      async validate () {
        this.$refs['validate-modal'].sending = true
        
        if (this.task.classification.key === 'revision_ponencia_subdirector_academico') {
          const response = await this.validatePresentation({
            presentation: this.task.taskable.id,
            validated: this.validated,
            comments: this.comments,
            task_id: this.task.id,
          })
          
          if (response.status === 'success') {
            AlertManager.success(response.message)
          }
          else {
            AlertManager.error(response.error)
          }
        }
        else {
          const response = await this.validatePresentationByResearchCommittee({
            presentation: this.task.taskable.id,
            is_included_on_indicators: this.isIncludedOnIndicators,
            comments: this.comments,
            task_id: this.task.id,
          })
          
          if (response.status === 'success') {
            AlertManager.success(response.message)
          }
          else {
            AlertManager.error(response.error)
          }
        }
        
        this.$refs['validate-modal'].sending = false
        this.$refs['validate-modal'].close()
        location.href = '/dashboard'
      },
    },
    data () {
      return {
        format: null,
        saving: false,
        title: '',
        content: '',
        okButtonText: '',
        validated: '',
        isIncludedOnIndicators: '',
        comments: '',
        participationTitles: {
          principal: 'Principal',
          principal_insp: 'Principal Interno INSP',
          coautor: 'Coautor',
          correspondencia: 'Correspondencia',
        },
        modalMessage: '',
      }
    },
    mounted () {
      const vm = this
      
      autosize($('textarea'))
      
      $('#frm-validate').validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          
          if (element.is(':radio')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
        },
        rules: {
          validated: {
            required: function (element) {
              return vm.task.classification.key === 'revision_ponencia_subdirector_academico'
            },
          },
          is_included_on_indicators: {
            required: function (element) {
              return vm.task.classification.key !== 'revision_ponencia_subdirector_academico'
            },
          },
          comments: {
            required: true,
          },
        },
        messages: {
          validated: {
            required: 'Este campo es requerido.',
          },
          is_included_on_indicators: {
            required: 'Este campo es requerido.',
          },
          comments: {
            required: 'Este campo es requerido.',
          },
        },
        submitHandler (form) {
          if (parseInt(vm.isIncludedOnIndicators)) {
            vm.modalMessage = `¿Está seguro de incluir la ponencia <b>${vm.task.taskable.title}</b> en indicadores?`
          } else {
            vm.modalMessage = `¿Está seguro de no incluir la ponencia <b>${vm.task.taskable.title}</b> en indicadores?`
          }

          $('#validate-modal').modal('show')
        },
      })
    },
  }
</script>
